<template>
  <otello-button
    :size="size"
    variant="clear"
    color-scheme="secondary"
    class="-ml-3 text-black-900 dark:text-slate-300"
    icon="list"
    aria-controls="secondary-sidebar"
    :aria-expanded="isMenuExpanded ? 'true' : 'false'"
    :aria-label="menuToggleLabel"
    :title="menuToggleLabel"
    @click="onMenuItemClick"
  />
</template>

<script>
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  props: {
    size: {
      type: String,
      default: 'small',
    },
  },
  data() {
    return {
      isMenuExpanded: false,
    };
  },
  computed: {
    menuToggleLabel() {
      return this.$t(
        this.isMenuExpanded ? 'SIDEBAR.COLLAPSE_MENU' : 'SIDEBAR.EXPAND_MENU'
      );
    },
  },
  mounted() {
    this.$emitter.on(
      BUS_EVENTS.SIDEMENU_STATE_CHANGED,
      this.handleSidemenuStateChanged
    );
    this.$emitter.emit(BUS_EVENTS.REQUEST_SIDEMENU_STATE);
  },
  beforeUnmount() {
    this.$emitter.off(
      BUS_EVENTS.SIDEMENU_STATE_CHANGED,
      this.handleSidemenuStateChanged
    );
  },
  methods: {
    handleSidemenuStateChanged(isExpanded) {
      this.isMenuExpanded = Boolean(isExpanded);
    },
    onMenuItemClick() {
      this.$emitter.emit(BUS_EVENTS.TOGGLE_SIDEMENU);
    },
  },
};
</script>
